import axios from "axios";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { HttpError } from "@/types/error";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const startClosedCaptioning = async (
  bearerToken: string,
): Promise<{ data: { subscriptionToken: string } }> => {
  const vidyoServices = await axios.get<{
    closedCaption: {
      url: string;
    };
  }>(import.meta.env.VITE_VIDYO_SERVICES_URL);

  const response = await axios.get(
    `${vidyoServices.data.closedCaption.url}/startClosedCaptioning`,
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    },
  );
  return response.data;
};

export function useStartClosedCaptioning(
  queryOptions?: Partial<
    UseQueryOptions<{ data: { subscriptionToken: string } }, HttpError>
  >,
) {
  const vidyoConnector = useVidyoStore((state) => state.vidyoSDK);
  const isVidyoConnected = useVidyoStore((state) => state.isVidyoConnected);
  const enabled = useVidyoStore((state) => state.closedCaptioning.enabled);

  const getToken = async () => {
    const jwtResult = await vidyoConnector?.GetJWTToken();
    const jwtToken = jwtResult?.jwtToken;
    return jwtToken ?? "";
  };

  return useQuery({
    queryKey: ["closed-captioning-token"],
    queryFn: async () => startClosedCaptioning(await getToken()),
    enabled: isVidyoConnected && enabled,
    ...queryOptions,
  });
}
